import { FloatingSidebarLayout } from "@/components/flow/shared/FullScreenModal";

export function ModelLayout({
    Sidebar,
    VisualArea
}: {
    Sidebar?: React.ReactNode;
    VisualArea: React.ReactNode;
}) {
    return <FloatingSidebarLayout VisualArea={VisualArea} Sidebar={Sidebar} />;
}
